/**
 * External dependencies.
 */
import { __, _x } from '@wordpress/i18n';
import {
	InspectorControls,
	useBlockProps,
	__experimentalUnitControl as UnitControl // eslint-disable-line
} from '@wordpress/block-editor';
import {
	PanelBody,
	__experimentalToggleGroupControl as ToggleGroupControl, // eslint-disable-line
	__experimentalToggleGroupControlOption as ToggleGroupControlOption // eslint-disable-line
} from '@wordpress/components';

export default ( props ) => {
	const { attributes: { draweropenverposition, draweropenhorposition, drawerhorpositionoffset, drawerverpositionoffset }, setAttributes } = props;

	const blockProps = useBlockProps( {
		style: {
			fontFamily: 'var(--portal-font-family)',
		},
		className: 'suredash-portal__editor-content',
	} );

	const iconColor = props?.attributes?.style?.elements?.iconcolor?.color?.stroke || '';

	return (
		<>
			<InspectorControls>
				<PanelBody>
					<ToggleGroupControl
						__nextHasNoMarginBottom
						label={ __( 'Drawer Open Vertically', 'suredash' ) }
						value={ draweropenverposition }
						onChange={ ( draweropenverposition ) => setAttributes( { draweropenverposition } ) } // eslint-disable-line
						isBlock
					>
						<ToggleGroupControlOption
							value="top"
							label={ _x(
								'Top',
								'Open at top direction',
								'suredash'
							) }
						/>
						<ToggleGroupControlOption
							value="bottom"
							label={ _x(
								'Bottom',
								'Open at bottom direction',
								'suredash'
							) }
						/>
					</ToggleGroupControl>

					<UnitControl
						label={ __( 'Vertical Position Offset', 'suredash' ) }
						labelPosition="top"
						__unstableInputWidth="80px"
						value={ drawerverpositionoffset }
						onChange={ ( drawerverpositionoffset ) => setAttributes( { drawerverpositionoffset } ) } // eslint-disable-line
					/>

					<ToggleGroupControl
						__nextHasNoMarginBottom
						label={ __( 'Drawer Open Horizontally', 'suredash' ) }
						value={ draweropenhorposition }
						onChange={ ( draweropenhorposition ) => setAttributes( { draweropenhorposition } ) } // eslint-disable-line
						isBlock
					>
						<ToggleGroupControlOption
							value="left"
							label={ _x(
								'Left',
								'Open at left position',
								'suredash'
							) }
						/>
						<ToggleGroupControlOption
							value="right"
							label={ _x(
								'Right',
								'Open at right position',
								'suredash'
							) }
						/>
					</ToggleGroupControl>

					<UnitControl
						label={ __( 'Horizontal Position Offset', 'suredash' ) }
						labelPosition="top"
						__unstableInputWidth="80px"
						value={ drawerhorpositionoffset }
						onChange={ ( drawerhorpositionoffset ) => setAttributes( { drawerhorpositionoffset } ) } // eslint-disable-line
					/>
				</PanelBody>
			</InspectorControls>

			<div { ...blockProps }>
				<style>
					{ `
						.wp-block-suredash-notification .portal-notification-trigger svg {
							stroke: ${ iconColor };
						}
					` }
				</style>

				<a href="javascript:void(0)" className="portal-notification-trigger portal-content"> {/* eslint-disable-line */}
					<span className="portal-svg-icon portal-icon-md" aria-hidden="true" aria-label="Bell">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-bell"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path></svg>
					</span>
					<span className="notification-unread-count sd-absolute sd-flex sd-items-center sd-justify-center sd-font-12 sd-max-h-20 sd-font-medium sd-bg-danger sd-color-white sd-min-w-20 sd-nowrap sd-radius-9999"> 4 </span>
				</a>
			</div>
		</>
	);
};
